export const SENT_MESSAGE_REQUEST = "SENT_MESSAGE_REQUEST";
export const SENT_MESSAGE_SUCCESS = "SENT_MESSAGE_SUCCESS";
export const SENT_MESSAGE_FAILURE = "SENT_MESSAGE_FAILURE";
// export const RECEIVED_MESSAGE_REQUEST = "RECEIVED_MESSAGE_REQUEST";
export const RECEIVED_MESSAGE_SUCCESS = "RECEIVED_MESSAGE_SUCCESS";
// export const RECEIVED_MESSAGE_FAILURE = "RECEIVED_MESSAGE_FAILURE";